var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-step-component"},[(_vm.secondStepWindow === 'address')?_c('address-window'):_vm._e(),(_vm.secondStepWindow === 'payment')?_c('payment-window'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }